import React from 'react'
import { connect, Field, FieldArray, FastField } from 'formik'
import { Button, Grid, FieldGroup, FormikInputField, FormikLayoutSelect } from '@paintscout/ui'
import { FormikHtmlEditor, FormikEmbedMedia, FormikDropdownSelect } from '@paintscout/ui-business'
import type {
  PresentationSectionFormProps,
  FormikPresentationSectionConnectProps,
  FormikPresentationSectionValues
} from '../../'
import { MoveRemoveButtons } from '../../util'

const ServicesForm = ({ formik }: PresentationSectionFormProps & FormikPresentationSectionConnectProps) => {
  const { section } = formik.values

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={12}>
          <Field component={FormikInputField} fullWidth={true} name={'section.title'} label={'Title'} />
        </Grid>
        <Grid item md={4}>
          <Field
            component={FormikDropdownSelect}
            fullWidth={true}
            name={'section.fields.width'}
            label="Width"
            options={[
              { label: 'Small', value: 'small' },
              { label: 'Medium', value: 'medium' },
              { label: 'Large', value: 'large' }
            ]}
          />
        </Grid>
        <Grid item md={4}>
          <Field component={FormikLayoutSelect} label={'Alignment'} name="section.fields.alignment" vertical={true} />
        </Grid>

        <Grid item md={12}>
          <FieldGroup label={'Services'}>
            <Grid container spacing={3}>
              <FieldArray
                name="section.fields.rows"
                render={(arrayHelpers) => (
                  <>
                    {(section?.fields?.rows ?? []).map((row, index) => (
                      <Grid item md={12} key={index}>
                        <ServicesRow section={section} arrayHelpers={arrayHelpers} index={index} />
                      </Grid>
                    ))}
                    <Grid item md={12}>
                      <Button
                        onClick={() => {
                          arrayHelpers.push({ image: null, title: '', content: '' })
                        }}
                        variant={'outlined'}
                        fullWidth={true}
                      >
                        Add Row
                      </Button>
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </FieldGroup>
        </Grid>
      </Grid>
    </>
  )
}

function ServicesRow({ index, section, arrayHelpers }) {
  return (
    <Grid container spacing={3} alignItems={'flex-start'}>
      <Grid item xs={12} md={3}>
        <Field
          component={FormikEmbedMedia}
          name={`section.fields.rows.${index}.image`}
          maxWidth={600}
          maxHeight={600}
          buttonHeight={100}
          quality={1}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <Grid container spacing={3} alignItems={'flex-start'}>
          <Grid item xs={12} md={5}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Field
                  component={FormikInputField}
                  label={'Title'}
                  fullWidth={true}
                  name={`section.fields.rows.${index}.title`}
                />
              </Grid>
              {section?.fields?.rows.length > 1 && (
                <Grid item xs={12}>
                  <MoveRemoveButtons arrayHelpers={arrayHelpers} index={index} section={section} horizontal={true} />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} md={7}>
            <FastField
              component={FormikHtmlEditor}
              label={'Description'}
              name={`section.fields.rows.${index}.content`}
              fullWidth={true}
              debounce={true}
              toolbar={{
                headings: true,
                align: true
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default connect<PresentationSectionFormProps, FormikPresentationSectionValues>(ServicesForm)
